// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_html-css_html-css_module_ts":"ef8ed43aacc81cc20ef7","src_app_modules_resources_resources_module_ts":"6ea0077f66f5a6712d50","src_app_modules_colleges_colleges_module_ts":"af05d3dd787d6273f5d3"}[chunkId] + ".js";
};